module.exports = __webpack_public_path__ + "img/plataformaInterativa_SMALL.a939271f.jpg";